import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=c551cb04&scoped=true"
import script from "./Checkboxes.vue?vue&type=script&lang=js"
export * from "./Checkboxes.vue?vue&type=script&lang=js"
import style0 from "./Checkboxes.vue?vue&type=style&index=0&id=c551cb04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c551cb04",
  null
  
)

export default component.exports